import '../App.css';
import { useState, useContext } from 'react';
import { DynamicHeader, GetDimensions } from '../components/Header';
import Footer from '../components/Footer';
import { TitleCards } from '../TitleCards';
import { scrollToSection } from '../components/Header';

export default function SwingTheory() {

    const { profile, project, contact } = useContext(TitleCards);
    const [pageRendered, setPageRendered] = useState(true);

    const tennisballSVG =
    <g fill='#096b0480' xmlns="http://www.w3.org/2000/svg">
    <path class="st0" d="M270.53,468.118c-20.387-26.737-29.981-61.49-30.024-98.106c0.026-39.603,11.328-81.828,34.762-119.712
		c23.407-37.842,59.256-71.257,107.614-91.956c26.798-11.484,44.555-23.545,56.125-35.158c8.783-8.861,14.21-17.36,17.721-26.048
		c-4.615-5.815-9.456-11.518-14.65-17.014C359.122-7.682,228.754-23.722,128.422,34.007c-3.702,5.315-7.162,10.716-10.147,16.264
		c-9.577,17.782-15.211,36.435-15.228,56.599c0.026,17.212,4.081,35.823,14.46,56.642c15.47,31.035,23.2,67.479,23.244,103.828
		c-0.026,30.973-5.668,61.956-18.059,89.401c-12.354,27.368-31.88,51.465-59.334,66.244c-0.328,0.173-0.673,0.329-1.001,0.501
		c2.451,2.821,4.935,5.625,7.524,8.37c65.891,69.73,161.652,94.207,248.526,72.447c-3.15-1.216-6.282-2.459-9.258-3.951
		C293.696,492.63,280.712,481.44,270.53,468.118z"/>
	<path class="st0" d="M481.784,135.264c-8.111,11.441-18.783,22.346-32.398,32.354c-13.701,10.104-30.336,19.438-50.49,28.084
		c-40.482,17.376-69.67,44.735-89.083,76.002c-19.378,31.233-28.688,66.469-28.661,98.306c-0.018,22.087,4.468,42.431,12.51,58.608
		c8.084,16.23,19.336,28.188,33.674,35.383c9.603,4.797,20.793,7.593,34.296,7.61c13.14,0,28.662-2.969,46.254-9.56
		c8.274-6.117,16.298-12.717,23.959-19.964C517.702,360.969,534.975,234.605,481.784,135.264z"/>
	<path class="st0" d="M100.105,267.34c0.043-30.474-6.747-61.354-18.946-85.65c-12.908-25.771-18.766-51.016-18.749-74.82
		c0-6.894,0.638-13.589,1.553-20.198c-75.046,84.985-84.442,208.725-26.142,303.4c2.113-0.923,4.271-1.803,6.272-2.873
		c12.14-6.548,22.234-15.91,30.56-27.748C91.321,335.879,100.174,302.023,100.105,267.34z"/>
    </g>

    return (
        <div className='page-container swing-page' style={{ backgroundSize: '100% 100%' }}>
            {pageRendered && scrollToSection('new_page')}
            {pageRendered && setPageRendered(false)}

            <DynamicHeader 
            visible={true}
            menu={GetDimensions().width < 600}
            profile={profile}
            project={project}
            contact={contact}
            />

            <div className='falling-leaves'>
                {[...Array(5)].map((_, i) => (
                    <svg key={i} className='falling-leaf-svg' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        {tennisballSVG}
                    </svg>
                ))}
            </div>

            <div className='caesar-column'>

                {GetDimensions().width < 600 && <div className='column'></div>}

                <div className='project-page'>

                    <div className='project-image-container swing-title-container'>
                        <>SWING</><>THEORY</>
                    </div>

                    <div className='caesar-intro-container'>                   

                        <span className='swing-subtitle'>The last tennis coach you'll ever need!</span><br/><br/>

                    </div>

                    <div className='project-page-desc-container'>
                        <h2>THE PURPOSE OF SWING THEORY</h2>
                        <span className='swing-subtitle'>WHY WE BUILT IT?</span>
                        <div className='project-page-desc'>
                            Swing Theory is a useful app that helps anyone learn tennis anywhere.
                            It utilises AI to analyze your swing and provide personalized feedback, 
                            making it easier than ever to improve your game.
                            <br/><br/>
                            Whether you're a beginner looking to learn the basics or an experienced 
                            player aiming to refine your technique, Swing Theory offers a convenient 
                            and effective way to enhance your tennis skills.
                        </div>

                        <h2>THE GENIUS BEHIND SWING THEORY</h2>
                        <span className='swing-subtitle'>HOW DOES IT WORK?</span>
                        <div className='project-page-desc'>
                            The app is designed to be user-friendly and intuitive. You simply navigate
                            through the app and work on the shot of your choice.
                            <br/><br/>
                            Record your swing and our AI will analyze it, providing you with 
                            detailed feedback on your technique - comparing it with a database 
                            of professional swings to identify areas for improvement.
                            <br/><br/>
                            The app's user flow mimics the process that real tennis coaches use 
                            when analyzing a player's swing and providing feedback. This allows
                            the user to learn in a way that feels close to being on the court 
                            with a coach, without the need for in-person sessions - reducing cost
                            and increasing accessibility.
                            
                        <h2>THE LOGIC BEHIND THE APP</h2>
                            <ul>
                                <li>
                                    <span className='swing-subtitle' style={{ fontWeight: '700' }}>User Interaction: </span>
                                    The user picks a shot they want to work on and choose how many
                                    swings they want to record. Once they are finished the AI will take some time
                                    analysing and then provide feedback. The user can then try to implement 
                                    the feedback and record more swings to see if they are improving. Over time
                                    they can see their history and track their progress.
                                </li>
                                <br/>
                                <li>
                                    <span className='swing-subtitle' style={{ fontWeight: '700' }}>Machine Learning: </span>
                                    Our AI model was trained on 3 distinct points in the shot - the start (backswing), 
                                    the middle (contact) and the end (follow through). By analyzing these key points,
                                    the model can identify where the users swing may be off and give feedback
                                    at each point.
                                </li>
                            </ul>
                        </div>
                        <h2>LIMITATIONS</h2>
                        <span className='swing-subtitle'>WHAT TO WORK ON FOR THE FUTURE</span>
                        <div className='project-page-desc'>
                             <ul>
                                <li>
                                    <span className='swing-subtitle' style={{ fontWeight: '700' }}>Differences of Swings: </span>
                                    In tennis, and sports in general, there is no one "correct" way to perform a movement. 
                                    Different players have different styles and techniques that work best for them. 
                                    This can make it difficult for an AI model to provide accurate feedback, as it 
                                    may not be able to account for the nuances of each player's swing.
                                    <br/><br/>
                                    <span className='swing-subtitle' style={{ fontWeight: '500' }}>Potential Fix: </span>
                                    Addressing this is hard, and is what makes coaches so important. However, the more data
                                    the AI can be trained on, the more it can learn to recognise different styles and techniques 
                                    and provide more personalized feedback to each user.
                                </li>
                                <br/>
                                <li>
                                    <span className='swing-subtitle' style={{ fontWeight: '700' }}>Tennis Overall: </span>
                                    Tennis is quite a complex sport, so as good as it is to improve your swing technique, 
                                    there are many other aspects of the game that are just as important - such as footwork, 
                                    movement on the court, strategy and mental toughness.
                                    <br/><br/>
                                    <span className='swing-subtitle' style={{ fontWeight: '500' }}>Potential Fix: </span>
                                    Adding in tips on when to use certain shots, and providing footwork drills to do while
                                    you are waiting for the AI to analyse your shots can help improve footwork and strategy
                                    and help players become more well rounded players.
                                    <br/><br/>

                                </li>
                            </ul>
                        </div>
                        
                    </div>

                </div>
                {GetDimensions().width < 600 && <div className='column'></div>}
            </div>
            <Footer/>              
        </div>
    )
}